// Operation type configurations driving the OperationRecord page.
// Each entry defines tab-specific fields (with rename templates) used by file uploaders.

export const LOGO_MIFORMALIN = "https://customer-assets.emergentagent.com/job_4f8e84c3-5378-4459-8f0b-9675e45da8e5/artifacts/fj2q4xa0_LOGO%20MIFORMALIN.png";
export const LOGO_DOKSIK = "https://customer-assets.emergentagent.com/job_4f8e84c3-5378-4459-8f0b-9675e45da8e5/artifacts/j1qoe9nc_LOGO%20DOKSIK.png";

// Build "Foto Pemeriksaan" label based on code
const fotoRiksaLabel = (code) => (["OTOPSI", "EKSHUMASI"].includes(code) ? "Foto Pemeriksaan Jenazah" : ["VISUM", "PL"].includes(code) ? "Foto Pemeriksaan Korban" : code === "OTKP" ? "Foto TKP" : code === "SAMPLING" ? "Foto Subjek/Objek" : "Foto");

const fotoRiksaPrefix = (code) => ({
  OTOPSI: "RIKSA JENAZAH", EKSHUMASI: "RIKSA JENAZAH",
  VISUM: "RIKSA KORBAN", PL: "RIKSA KORBAN",
  OTKP: "FOTO TKP", SAMPLING: "FOTO OBJEK",
}[code] || "FOTO");

export const STANDARD_CODES = ["OTOPSI", "EKSHUMASI", "VISUM", "PL"];
export const REQUEST_LETTER_CODES = ["OTKP", "SAMPLING", "SAKSI"]; // surat permintaan (not SPV)
export const DVI_CODE = "DVI";

export function getOpConfig(code, opName) {
  const N = opName || "operasi";
  // Whether persiapan uses SPV or "Surat Permintaan"
  const isStandard = STANDARD_CODES.includes(code);
  const isRequest = REQUEST_LETTER_CODES.includes(code);
  const isDVI = code === DVI_CODE;

  return {
    code,
    isDVI,
    persiapan: {
      letter: {
        title: isStandard ? "Surat Permintaan Visum (SPV)" : isDVI ? null : "Surat Permintaan Kegiatan",
        prefix: isStandard ? `SPV-${code}-${N}` : `SURAT PERMINTAAN-${code}-${N}`,
        fields: isDVI ? [] : ["instansi_penerbit", "tanggal_surat", "nama_kontak", "nomor_kontak"],
      },
      sprin: {
        title: "Surat Perintah Operasi (SPRIN)",
        prefix: `SPRIN-${code}-${N}`,
      },
    },
    pelaksanaan: {
      fotoRiksaLabel: fotoRiksaLabel(code),
      fotoRiksaPrefix: `${fotoRiksaPrefix(code)}-${code}-${N}`,
      dokGiatPrefix: `DOKGIAT-${code}-${N}`,
      obduksiLabel: code === "OTKP" ? "Temuan Lapangan" : (code === "SAMPLING" || code === "SAKSI") ? "Laporan Kegiatan" : code === "DVI" ? null : "Obduksi",
      obduksiPrefix: code === "OTKP" ? `SKETSA-${code}-${N}` : (code === "SAMPLING" || code === "SAKSI") ? `LAPGIAT-${code}-${N}` : code === "DVI" ? null : `OBDUKSI-${code}-${N}`,
      sampleType: code === "SAKSI" ? "barang_bukti" : isDVI ? "dvi_pemeriksaan" : code === "OTKP" || code === "SAMPLING" || code === "DVI" ? "sample" : "sample",
      hasSamples: !isDVI && code !== "SAKSI",
      hasBarangBukti: code === "SAKSI",
      sampleCodePrefix: code,
      serahTerimaSampelPrefix: `SERAH TERIMA SAMPEL-${code}-${N}`,
      serahTerimaBBPrefix: `SERAH TERIMA BARANG BUKTI-${code}-${N}`,
    },
    pelaporan: {
      hasVer: ["OTOPSI", "EKSHUMASI", "VISUM", "PL"].includes(code),
      labPrefix: `LAB-001-${code === "DVI" ? "PM DVI" : code === "SAMPLING" ? "SAMPLING" : code}-${N}`,
      serahTerimaLabPrefix: `SERAH TERIMA LAB-${code === "DVI" ? "PM DVI" : code}-${N}`,
      verPrefix: `VeR-${code}-${N}`,
      serahTerimaVerPrefix: `SERAH TERIMA VeR-${code}-${N}`,
      perwabkeuPrefix: code === "SAKSI" ? `Perwabkeu-SAKSI AHLI-${N}` : `Perwabkeu-${code}-${N}`,
    },
  };
}

export const OP_TYPE_NAMES = {
  OTOPSI: "Otopsi",
  EKSHUMASI: "Ekshumasi",
  VISUM: "Visum Korban Hidup",
  PL: "Pemeriksaan Luar Jenazah",
  OTKP: "Olah TKP Aspek Medis",
  SAMPLING: "Pengambilan Sampel Medis",
  SAKSI: "Saksi Ahli",
  DVI: "Operasi DVI",
};
